module.exports = __webpack_public_path__ + "static/media/6.cf19aaa4.png";